import React, {useEffect, useState} from "react";
import { Helmet } from "react-helmet";
import { Button, Form, Input, Modal, Spin } from "antd";
import "~assets/css/common.css";
import { MESSAGE_ERROR, replaceAttr } from "~utils/constants/message-const";
import * as Utils from "~utils";
import { API_CONST, MAIL_USER, URL } from "~utils/constants/api-const";
import { navigate } from "gatsby";
import { connectPost } from "~utils/api-utils";
import {getTimeLoadDom} from "~utils";

const ResetPassword = () => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [rendered , setRendered]  = useState(false)

  /**
   * Check exist email
   *
   * @param params
   */
  const checkExistEmail = async (params) => {
    return await Utils.API.connectGet<MAIL_USER>(
      API_CONST.CHECK_EXIST_EMAIL_API + params,
      {}
    );
  };

  /**
   * Validate format email
   *
   * @param value
   */
  const validateFormatEmail = async (_, value) => {
    if (!value) {
      return Promise.resolve();
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(value)) {
      let params = "?email=" + value.trim();
      const e = await checkExistEmail(params);
      const data = e?.res.data.data;
      //check mail not exist
      if (!data.is_exist) {
        return Promise.reject(
          replaceAttr(MESSAGE_ERROR.E0061, { attr: "メールアドレス" })
        );
      }
    }

    return Promise.resolve();
  };

  /**
   * handle when input mail on blur
   *
   * @param e
   */
  const handleOnblur = (e: { target: { name: any; value: any } }) => {
    setEmailValue(e.target.value);
  };

  /**
   * submit form
   *
   */
  const onFinish = async () => {
    setIsLoading(true);
    const response = await connectPost(
      API_CONST.USER_SEND_MAIL_FORGOT_PASSWORD,
      { mail_address: emailValue.trim() }
    );
    const data = response?.res.data.data;
    const err = response?.res.data.error;
    if (data) {
      sessionStorage.setItem("send-mail-success", "true");
      await navigate(URL.USER_RESET_PASSWORD_THANKS);
      return;
    } else {
      Modal.error({
        style: {},
        title: "エラー",
        okText: "確認",
        content: err.message,
      });
    }
    setIsLoading(false);
  };

  /**
   * handle back button
   *
   * @param values
   */
  const back = async () => {
    await navigate(URL.USER_LOGIN);
  };

  React.useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setIsSubmit(true);
      },
      () => {
        setIsSubmit(false);
      }
    );
  }, [emailValue]);

  useEffect(() => {
    const delay = getTimeLoadDom();

    const timeoutId = setTimeout(() => {
      setRendered(true);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, []);
  return (
    <>
      <Helmet>
        <title>パスワードの再設定</title>
        <link rel="icon" type="image/x-icon" href="/web.d/images/favicon.ico"/>
      </Helmet>
      <div className={`main-page ${!rendered ? "display-none" :""}`}>
        <div className={`main-page-container`}>
          <h4 className="main-page-header ">パスワードの再設定</h4>
          <Form
            form={form}
            name="forgot-password"
            onFinish={onFinish}
            validateTrigger="onBlur"
          >
            <div className="main-page-content">
              <p className="main-page-content-text">
                パスワード再設定用のURLをメールにてご連絡致します。
              </p>
              <p className=" main-page-content-text">
                メールアドレスを入力してください。
              </p>
              <div className="main-page-form-content">
                <Form.Item
                  className="main-page-form-content-item"
                  name="email"
                  label="メールアドレス"
                  rules={[
                    {
                      type: "email",
                      message: replaceAttr(MESSAGE_ERROR.E0004, {
                        attr: "メールアドレス",
                      }),
                    },
                    {
                      required: true,
                      message: replaceAttr(MESSAGE_ERROR.E0002, {
                        attr: "メールアドレス",
                      }),
                    },
                    { validator: validateFormatEmail },
                  ]}
                >
                  <Input
                    onBlur={handleOnblur}
                    name="mail_address"
                    placeholder="メールアドレス"
                  />
                </Form.Item>
              </div>
            </div>
            <div
              style={{ marginTop: "1em" }}
              className="user-register-confirm-footer"
            >
              <Form.Item className={"main-button-form"}>
                <Button
                  disabled={!isSubmit}
                  className="main-button main-button-submit"
                  type="primary"
                  htmlType="submit"
                >
                  送信
                </Button>
              </Form.Item>
              <Form.Item className={"main-button-form"}>
                <Button onClick={back} className="main-button main-button-back">
                  戻る
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
      <Spin spinning={isLoading || !rendered} fullscreen />
    </>
  );
};

export default ResetPassword;
